import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { alertService } from '../../services/helpers/alert.service';
import { searchService } from "../../services/api/search.service";
import { reportService } from "../../services/api/report.service";
import { utils } from "../../services/helpers/utils";

export const SearchConsultations = (props) => {
    const { partener, deladata, ladata, cnp, status_finalizare, status_aprobare, numePacient, companie, emisDe } = props.params;
    const [consultatii, setConsultatii] = useState(null);
    const navigate = useNavigate();

    const params = {
        partner: partener?.id,
        datastart: deladata ? utils.convertDate(deladata) : "",
        dataend: ladata ? utils.convertDate(ladata) : "",
        cnp: cnp,
        statusfinalizare:  status_finalizare.id ?? 0,
        statusaprobare: status_aprobare.id ?? 0,
        numepacient: numePacient ?? "",
        companie: companie ?? ""
    }

    useEffect(() => {

        if (utils.checkEmptyProperties(props.params)) {
            alertService.error("Trebuie sa completezi macar un parametru!");
        }
        else {

            searchService.getConsultations( params )
                .then(response => {
                    if (response) {
                        setConsultatii(response);
                    }
                    else {
                        setConsultatii(null);
                    }
                });
        }
    }, [props.params]);

    const handleConsultation = (consultatie) => {

        var encode = {
            displayValue: props.params,
            activeComponent: props.activeComponent
        };

        var encodedString = btoa(JSON.stringify(encode));

        navigate(window.location.hash + `?q=${encodedString}`, { replace: true });
        navigate(`/dashboard/consultatie?consultatie=${consultatie.idConsultatie}`);
    }

    const handleExport = () => {
        reportService.RaportCautareConsultatii(
            {
                cnp: params.cnp,
                deLaData: params.datastart,
                laData: params.dataend,
                statusFinalizare: params.statusfinalizare,
                idPartener: params.partner,
                nume: params.numepacient ,
                companie: params.companie
            }
        ).then((response) => {
            if (response) {
                utils.downloadFile(response, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                return;
            }
        });
    }

    return (
        <>
            {consultatii &&
                <>
                    <p className="paragraf">Consultatiile:</p>
                    <table className="tbl" name="lista" width="100%">
                        <thead>
                            <tr>
                                <th className="first">Nr</th>
                                <th>Pacient</th>
                                <th>CNP</th>
                                <th>Cod pacient</th>
                                <th>Companie</th>
                                <th>Abonament</th>
                                <th>Medic intern</th>
                                <th>Medic trimitator</th>
                                <th>Status</th>
                                <th>Adaugat la</th>
                                <th>Partener</th>
                                <th>ID Cons</th>
                                <th className="tac">Vezi consultatie</th>
                            </tr>
                        </thead>
                        <tbody>
                            {consultatii.map((consultatie, index) => (
                                <tr key={index}>
                                    <td name="nr_crt" className="center">{index + 1}</td>
                                    <td name="nume_pacient">{consultatie.pacient}</td>
                                    <td name="cnp" className="center">{consultatie.cnp}</td>
                                    <td name="cod_pacient" className="center">{consultatie.codPacient}</td>
                                    <td name="nume_firma">{ consultatie.companie}</td>
                                    <td name="nume_profil">
                                        {consultatie.abonament}
                                        {consultatie.firmaMaster && <span> (</span>}
                                        {consultatie.firmaMaster}
                                        {consultatie.firmaMaster && <span>)</span>}
                                    </td>
                                    <td name="nume_medic">{ consultatie.medic }</td>
                                    <td name="nume_medic_ext">{ consultatie.medicTrimitator}</td>
                                    <td name="status" className="center">{ consultatie.status }</td>
                                    <td name="adaugat_la" className="center">{consultatie.adaugatLa}</td>
                                    <td name="partener" className="center">{consultatie.partener}</td>
                                    <td className="center">{consultatie.idConsultatie}</td>
                                    <td>
                                        <a className="icon deschide m0auto"
                                            onClick={() => handleConsultation(consultatie)}
                                            title="Vezi consultatie" name="view">Vizualizare</a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div name="export">
                        <button name="btn-export" className="btn" onClick={handleExport}>Export</button>
                    </div>
                </>
            }
        </>
    );
};

